import { type DeepPartial } from '@direct-frontend/stdlib';
import { EMPTY_DASH } from '#shared/lib/constants';
import { type PromoactionModel } from './types';

export const getPromoactionMinimumOrderAmountText = (promoaction: DeepPartial<PromoactionModel>): string => {
    const minimumOrderAmount = promoaction.discount?.minimum_order_amount;

    if (!minimumOrderAmount) {
        return EMPTY_DASH;
    }

    return minimumOrderAmount;
};
